import { render, staticRenderFns } from "./TheMenus.vue?vue&type=template&id=6673574d&scoped=true&"
import script from "./TheMenus.vue?vue&type=script&lang=js&"
export * from "./TheMenus.vue?vue&type=script&lang=js&"
import style0 from "./TheMenus.vue?vue&type=style&index=0&id=6673574d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6673574d",
  null
  
)

export default component.exports